<template>
	<div class="moderatorChatConversation">
		<div
			v-if="chat"
			ref="scrollToBottom"
			class="moderatorChatConversation-messages"
		>
			<!-- @vue-expect-error -->
			<div
				:class="conversationMessageClasses(message)"
				v-for="message in this.chat.messages"
				:key="'conversationMessage-' + message.id"
			>
				<div
					class="conversationMessage-content"
					v-html="message.content_as_html"
				></div>
				<time
					class="timeago"
					:datetime="message.created_at"
					:data-time-ago="message.created_at"
				></time>
			</div>
		</div>
		<div class="moderatorChatConversation-form">
			<textarea v-model="replyContent" class="j-autosize-disabled" />
			<button
				class="pull-right"
				:disabled="!canSendReply"
				v-on:click="sendMessage"
			>
				{{ t("helpers.submit.message.create") }}
				{{ sending ? "…" : "" }}
			</button>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
// Other components
import { i18n } from "../utils";

export default {
	// Naming - server = srv
	mixins: [i18n],
	props: ["chat", "sending"],
	data: function () {
		return {
			replyContent: "",
		};
	},
	computed: {
		canSendReply: function () {
			return this.replyContent.length && !this.sending;
		},
	},
	update() {
		this.scrollToChatBottom();
	},
	mounted() {
		this.scrollToChatBottom();
		this.$watch("chat.messages", this.messagesChanged, {});

		window.$(".moderatorChatConversation .timeago").timeago();
	},
	methods: {
		messagesChanged() {
			this.scrollToChatBottom();
			Vue.nextTick(() => {
				window.$(".moderatorChatConversation .timeago").timeago();
			});
		},
		sendMessage() {
			this.$emit("replied", {
				actor: this.chat ? this.chat.actor : undefined,
				messageContent: this.replyContent,
			});
			this.replyContent = "";
			window.$(".moderatorChatConversation-form textarea").focus(); //.select()
		},
		scrollToChatBottom() {
			Vue.nextTick(() => {
				var elem = this.$refs.scrollToBottom;
				if (this.$refs.scrollToBottom) {
					// @ts-expect-error
					elem.scrollTop = this.$refs.scrollToBottom.scrollHeight;
				}
			});
		},
		conversationMessageClasses(message) {
			let classes = "moderatorChatConversation-message";
			if (message.from_moderator) {
				classes += " moderatorChatConversation-message-fromModerator";
			}
			return classes;
		},
	},
};
</script>
